<template>
	<MainLayout>
		<div class="container">
			<div class="box">
				<div v-if="showFormZonedArea">
						<!-- Form for creating a new zoned area -->
						<!-- Form for creating a new zoned area -->
						<div>
							<b-form @submit.prevent="createZonedArea" >
								<b-row class="justify-content-center">
									<b-col lg="4">
										<b-form-group
										:label="$t('global.name')"
										label-for="name"
										>
										<b-form-input
											id="name"
											v-model="zonedArea.name"
											required
										></b-form-input>
										</b-form-group>
									</b-col>
									<b-col lg="4">
										<b-form-group
										:label="$t('global.description')"
										>
										<textarea class="form-control" id="exampleFormControlTextarea1" rows="2" v-model="zonedArea.description"></textarea>
										</b-form-group>
									</b-col>
									<b-col lg="2" class="mt-5 text-center">
										<b-button variant="warning" @click="clickedCancelForm" class="mr-2">{{ $t("global.cancel") }}</b-button>
										<b-button type="submit" variant="primary">{{ $t("global.save") }}</b-button>
									</b-col>
								</b-row>
							</b-form>
						</div>
				</div>
				<section v-else>
					<div>
						<b-breadcrumb>
							<b-breadcrumb-item  @click.stop="$router.push('/operation-areas')" >
								<span > <md-icon icon="arrow_back"></md-icon> {{ $t("zonedArea.goToList") }}</span>
							</b-breadcrumb-item>
						</b-breadcrumb>
						<b-jumbotron class="p-2 mb-0" bg-variant="light">
							<template #header>
								<h3 class="mt-2">
									<b>
										[{{zonedArea.id}}] {{zonedArea.name}} <md-icon class="text-info" icon="beenhere" v-if="zonedArea.masterArea"/>
									</b>
									<b-button @click="showFormZonedArea=true" variant="outline-success" size="sm">{{ $t("global.toEdit") }}</b-button>
								</h3>
							</template>
							<b-row class="mt-1"></b-row>
							<hr class="my-3">
						</b-jumbotron>
					</div>

					<div style="position: relative;">
						<b-overlay :show="loading" no-wrap ></b-overlay>
						<MapZones
							v-if="zonedArea && zonedArea.zonesType=='polygon' "
							:zoned-area="zonedArea"
							@reFetch="fetchModel()"
						/>
					</div>
				</section>
			</div>
		</div>
	</MainLayout>
</template>

<script>
import MainLayout from '../layout/MainLayout.vue'
import MapZones from './MapZones'
export default {
	props: {
		zonedAreaId: {
			type: String,
			required: false
		}
	},
	components: { MainLayout,MapZones},
	data(){
			return {
				loading:false,
				zonedArea:  {id:-1,name:"",zonesType:""},
				showFormZonedArea:false,
				//__zonedAreaId:this.zonedAreaIdProp
			}
	},
	computed: {},
	methods:{
		fetchModel(){
			this.loading = true
			this.$root.api.get(`/zoned-areas/${this.zonedAreaId}`).then( res => {
				this.zonedArea = {...res.data}
				this.loading = false
			}).catch(this.$root.handleRequestError);
		},
		createZonedArea() {
			if(this.zonedAreaId>0){
				this.update();
			}else{
				this.store();
			}

		},
		store(){
			this.loading = true;
			// Send the zonedArea data to the server to create a new zoned area
			this.$root.api.post('/zoned-areas', this.zonedArea)
				.then((res) => {
					this.createdDone(res)
				})
				.catch(this.$root.handleRequestError);
		},
		update(){
			this.loading = true;
			this.$root.api.put('/zoned-areas/'+this.zonedAreaId,this.zonedArea)
				.then((res) => {
					this.updatedDone(res)
				})
				.catch(this.$root.handleRequestError);
		},
		updatedDone(){
			this.$root.showAlert(this.$t("global.correctlyAdded"),{varinat:"success"});
			this.showFormZonedArea = false;
			this.fetchModel();
		},
		createdDone(res){
			this.$root.showAlert(this.$t("global.correctlyAdded"),{varinat:"success"});
			this.$router.push('/operation-area/' + res.data.id);
			setTimeout(()=>{
				this.showFormZonedArea = false;
				this.fetchModel();
				this.$root.auxVars.loadResourcesOpts({vm: this,resourceNames: ["zonedAreasOpts"], forceRefresh: true});
			},0)

		},
		clickedCancelForm(){
			if(this.zonedAreaId=="new"){
				this.$router.push('/operation-areas');
				return;
			}
			this.showFormZonedArea = false;
		}

	},
	mounted(){
		if(this.zonedAreaId !=="new"){
			this.fetchModel()
		}else{
			this.showFormZonedArea = true;
		}

	}
}
</script>

<style>

</style>
